<div>
    <label>Groups</label>
    <kendo-combobox [data]="employeeGroups"
                    [textField]="'name'"
                    [valueField]="'groupId'"
                    [valuePrimitive]="true"
                    [allowCustom]="false"
                    [(ngModel)]="selectedGroupId"
                    (selectionChange)="groupChanged($event.groupId)"
                    [popupSettings]="{ appendTo: 'component' }">
    </kendo-combobox>
</div>

<div>
    <label>Employees</label>
    <kendo-multiselect [data]="employees"
                       [textField]="'fullName'"
                       [valueField]="'employeeId'"
                       [(ngModel)]="selectedEmployees"
                       (valueChange)="selectionChanged()"
                       [popupSettings]="{ appendTo: 'component' }">
    </kendo-multiselect>
</div>

<div>
    <label>Additional Emails</label>
    <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
    <input type="text" class="form-control" [ngModel]="selectedEmails" (input)="emailsOnChange($event.target.value)" />
    <label class="text-danger">WARNING</label>: Do not send to any distribution list if any of those emails are included in the Employees or Additional Emails.
</div>